import m from "../../geodata/es2015/somaliaLow";
window.am4geodata_somaliaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/somaliaLow.js
// module id = null
// module chunks = 